import React from 'react';

export default function Footer() {
  return (
    <footer className="py-8 px-6 border-t border-ink/10">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="font-body text-xs text-muted">
          © {new Date().getFullYear()} Baki Sevgul — Running on a Raspberry Pi 4
        </p>
        <p className="font-body text-xs text-muted">
          Built with React · Tailwind · Docker
        </p>
      </div>
    </footer>
  );
}
